import clsx from 'clsx';

import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ReportStartEndRow from './ReportStartEndRow';
import ReportUsageRow from './ReportUsageRow';
import { ReportMaterial } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  startEndMaterials: ReportMaterial[];
  usageMaterials: ReportMaterial[];
  isCompletedOrAbove: boolean;
}

const ReportMaterials = ({
  startEndMaterials,
  usageMaterials,
  isCompletedOrAbove,
}: Props) => {
  const showStartEndSection = !isNilOrEmpty(startEndMaterials);
  const showUsageSection = !isNilOrEmpty(usageMaterials);

  return (
    <div>
      {showStartEndSection && (
        <>
          <div className={classes.materialTableHeader}>
            <div className={classes.materialTableSub}>
              <div className={classes.materialHeaderType}>Type</div>
              <div className={classes.materialHeaderName}>Name</div>
            </div>
            <div className={classes.materialTableSub}>
              <div className={classes.materialHeaderCell}>Start Reading</div>
              <div className={classes.materialHeaderCell}>End Reading</div>
              <div className={clsx(classes.materialHeaderCell, classes.used)}>
                Used
              </div>
              {isCompletedOrAbove && (
                <div className={classes.materialHeaderCell}>Cost</div>
              )}
            </div>
          </div>
          <div>
            {startEndMaterials.map(reportMaterial => (
              <ReportStartEndRow
                key={reportMaterial?.assetId}
                reportMaterial={reportMaterial}
                isCompletedOrAbove={isCompletedOrAbove}
              />
            ))}
          </div>
        </>
      )}
      {showUsageSection && (
        <>
          <div className={classes.materialTableHeader}>
            <div className={classes.materialTableSub}>
              <div className={classes.materialHeaderType}>Type</div>
              <div className={classes.materialHeaderName}>Name</div>
            </div>
            <div className={classes.materialTableSub}>
              <div className={clsx(classes.materialHeaderCell, classes.used)}>
                Used
              </div>
              {isCompletedOrAbove && (
                <div className={classes.materialHeaderCell}>Cost</div>
              )}
            </div>
          </div>
          <div>
            {usageMaterials.map(reportMaterial => (
              <ReportUsageRow
                key={reportMaterial?.assetId}
                reportMaterial={reportMaterial}
                isCompletedOrAbove={isCompletedOrAbove}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ReportMaterials;
